import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Icon from '@loggi/ui/components/icon';

function getSelectedMarker(isSelected) {
  return (
    <span className="Select-multi-marker">
      {isSelected && <Icon type="check" />}
    </span>
  );
}

export default function SelectOption({
  icon,
  label,
  isMulti,
  selected,
  options,
  divider
}) {
  const iconClass = icon ? `Select-icon ico ico-${icon}` : '';
  const isGroup = options && options.length > 0;
  const selectedDisplay = isMulti ? getSelectedMarker(selected) : null;
  const className = classNames(['Select-option-label', iconClass]);

  const classesLabel = classNames({ 'label-group': isGroup });

  return (
    <span>
      {divider && <hr />}
      <span className={className}>
        <span className={classesLabel}>{label}</span>
        {selectedDisplay}
      </span>
    </span>
  );
}

SelectOption.propTypes = {
  option: PropTypes.object.isRequired
};

SelectOption.displayName = 'SelectOption';
